import React from 'react'
import { Link } from "gatsby"
import { LaboratorioDeContenidosDeMarcaWhite } from "copesa-logos"
import { Container, StLogo } from "./Footer.css"

const Footer = () => (
  <Container>
    <Link to="/" className="slotLab">
      <StLogo>
        <LaboratorioDeContenidosDeMarcaWhite />
      </StLogo>
    </Link>
  </Container>
)

export default Footer